module.exports = __webpack_public_path__ + "static/img/banner-01.cbe9502.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/banner-01.jpg
// module id = DLLQ
// module chunks = 7